import { useCallback, useState } from 'react';

const INITIAL_STATE = {
  open: false,
  variant: 'error',
  title: '',
  message: '',
};

export default function useAuthMessageDialog() {
  const [dialog, setDialog] = useState(INITIAL_STATE);

  const closeDialog = useCallback(() => {
    setDialog((prev) => ({ ...prev, open: false }));
  }, []);

  const showError = useCallback((message, title = 'Error') => {
    setDialog({
      open: true,
      variant: 'error',
      title,
      message,
    });
  }, []);

  const showRegisterDialog = useCallback(() => {
    setDialog({
      open: true,
      variant: 'register',
      title: '',
      message: '',
    });
  }, []);

  return {
    dialog,
    closeDialog,
    showError,
    showRegisterDialog,
  };
}
